var installedModules = {};
var moduleToHandlerMapping = {
	36212: {
		getter: () => (Promise.all([__webpack_require__.e(222), __webpack_require__.e(400), __webpack_require__.e(964), __webpack_require__.e(909)]).then(() => (() => (__webpack_require__(37222))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=17.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech/ui-toolkit",
	},
	44098: {
		getter: () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(542)]).then(() => (() => (__webpack_require__(90011))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.95.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/dev-tools-utils",
	},
	45133: {
		getter: () => (Promise.all([__webpack_require__.e(806), __webpack_require__.e(620)]).then(() => (() => (__webpack_require__(8620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.95.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	64371: {
		getter: () => (Promise.all([__webpack_require__.e(475), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(15475))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.95.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	73122: {
		getter: () => (Promise.all([__webpack_require__.e(246), __webpack_require__.e(249), __webpack_require__.e(400)]).then(() => (() => (__webpack_require__(4249))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	5297: {
		getter: () => (Promise.all([__webpack_require__.e(735), __webpack_require__.e(964), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(99735))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=7.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-cloud-solutions/mcs-utils",
	},
	82964: {
		getter: () => (__webpack_require__.e(230).then(() => (() => (__webpack_require__(42230))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	53108: {
		getter: () => (__webpack_require__.e(750).then(() => (() => (__webpack_require__(8750))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=6.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	66758: {
		getter: () => (Promise.all([__webpack_require__.e(12), __webpack_require__.e(754), __webpack_require__.e(400), __webpack_require__.e(434)]).then(() => (() => (__webpack_require__(57754))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-cloud-solutions/tdl",
	},
	78773: {
		getter: () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(71924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=1.11.10",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	64400: {
		getter: () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(21653))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	60371: {
		getter: () => (__webpack_require__.e(230).then(() => (() => (__webpack_require__(42230))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.18.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	99328: {
		getter: () => (Promise.all([__webpack_require__.e(228), __webpack_require__.e(806), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(2227))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.95.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	688: {
		getter: () => (__webpack_require__.e(628).then(() => (() => (__webpack_require__(92628))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	57636: {
		getter: () => (Promise.all([__webpack_require__.e(246), __webpack_require__.e(591)]).then(() => (() => (__webpack_require__(92972))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	78750: {
		getter: () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(71924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=1.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	91052: {
		getter: () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(71924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 1.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	94254: {
		getter: () => (__webpack_require__.e(94).then(() => (() => (__webpack_require__(21094))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech/ui-icons",
	},
	2347: {
		getter: () => (Promise.all([__webpack_require__.e(839), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(45839))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=2.12",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-cloud-solutions/api-client",
	},
	53416: {
		getter: () => (Promise.all([__webpack_require__.e(580), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(25580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.94.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	54170: {
		getter: () => (Promise.all([__webpack_require__.e(839), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(45839))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=2.6.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-cloud-solutions/api-client",
	},
	62963: {
		getter: () => (Promise.all([__webpack_require__.e(735), __webpack_require__.e(964), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(99735))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-cloud-solutions/mcs-utils",
	},
	97584: {
		getter: () => (Promise.all([__webpack_require__.e(580), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(25580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=0.94.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	7264: {
		getter: () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(71924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"178": [
		36212,
		44098,
		45133,
		64371,
		73122
	],
	"264": [
		7264
	],
	"297": [
		5297
	],
	"400": [
		64400
	],
	"404": [
		53108,
		66758,
		78773
	],
	"542": [
		60371,
		99328
	],
	"909": [
		688,
		57636,
		78750,
		91052,
		94254
	],
	"953": [
		2347,
		53416,
		54170,
		62963,
		97584
	],
	"964": [
		82964
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}